/* WEB-07 (24-oct-2026) · Calculadora de talle dentro de los filtros, como el prototipo.
   Usa la MISMA guía (assets/guia-talles-data.json) y la MISMA cuenta que la ficha
   (num, esc, classify, ranges y recommend copiados tal cual de assets/guia-talles.js, la guía de la ficha — v3.8, contorno cómodo en elastizadas).
   - En el cajón de filtros: «¿No sabés tu talle? Calculalo con tus medidas» → «Tu talle en esta página» + «Usar estos talles».
   - En cada tarjeta del catálogo: «Tu talle: M» (se recuerda en este navegador). */
(() => {
  var DATA = null;
  function num(v) { var n = parseFloat(String(v).replace(",", ".")); return isNaN(n) ? null : n; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function classify(ch, label) {
    var cols = ch.cols || [], rows = ch.rows || [];
    if (!rows.length) return null;
    var entryIdx = (typeof ch.e === "number" && ch.e > 0) ? ch.e : -1;
    var entryCol = entryIdx > 0 ? (cols[entryIdx] || "") : "";
    var unstrIdx = -1, j;
    for (j = 1; j < cols.length; j++) if (/sin estirar/i.test(cols[j] || "")) { unstrIdx = j; break; }
    var elastic = entryIdx > 0 && (unstrIdx > 0 || /estirad|maxim/i.test(entryCol));
    var measure = /cader/i.test(entryCol) ? "cadera" : (/cintur/i.test(entryCol) ? "cintura" : "busto");
    var cintIdx = -1;
    if (measure === "cadera") for (j = 1; j < cols.length; j++) if (/cintur/i.test(cols[j] || "")) { cintIdx = j; break; }
    var name = ch.n || label || "";
    var buzo = /hoodie|canguro|buzo|campera/i.test(name);
    /* CALCE CALIBRADO (v2, 30-jul-2026)
       ch.t = holgura objetivo de ESTA prenda, derivada del talle que usan los modelos
       en las fotos del sitio (ficha del producto). Ya no se adivina por el nombre.
       Sin ancla propia -> mediana de su grupo (DATA.fb). min y snug son guardarraíles
       universales: solo evitan recomendar algo que no entra. */
    var ease = null, fit;
    var grupo = elastic ? "elastizada-busto" : (measure === "cadera" ? "pantalon" : (measure === "cintura" ? "cintura" : (buzo ? "abrigo" : "top")));
    var fb = (DATA && DATA.fb) ? DATA.fb : {};
    var target = (typeof ch.t === "number") ? ch.t : (typeof fb[grupo] === "number" ? fb[grupo] : (buzo ? 30 : 15));
    /* min y snug son guardarraíles, no calibración: solo evitan recomendar algo
       que no entra. Se toman del objetivo PERO nunca por encima de un piso bajo,
       para no dejar sin talle a quien igual entra cómodo en una prenda muy holgada. */
    var piso = (measure === "cadera") ? -2 : 2;
    var mn = Math.min(Math.round((target - 3) * 10) / 10, piso);
    ease = { min: mn, ideal: target, snug: Math.round((mn - 4) * 10) / 10 };
    if (entryIdx < 0) { ease = null; fit = "MEDIDAS"; }
    else if (elastic) { fit = "AL CUERPO · SE ESTIRA"; }
    else if (measure === "cadera") { fit = "JEAN / PANTALÓN"; }
    /* el badge describe el calce REAL medido, no el nombre comercial */
    else fit = target < 5 ? "AL CUERPO" : (target < 15 ? "REGULAR" : (target < 25 ? "HOLGADO" : "OVERSIZE"));
    /* ¿Se decide con la columna del CONTORNO CÓMODO? (v3.8, 4-sep-2026)
       La segunda columna de una prenda elastizada NO es el tope reventado del
       elástico: es hasta dónde la prenda viste CÓMODA. Por eso es la que manda
       para elegir talle, no la de reposo. Antes decidía el reposo y el cómodo
       solo filtraba si entrabas — eso ignoraba cuánto comprime cada tejido.
       Excepción `ch.ref === "reposo"`: tablas cuyo dato de cómodo no es confiable
       (ver CREAR-O-CAMBIAR-UNA-TABLA.md). Espejo de usa_comodo() en tools/lib.py. */
    var usaComodo = elastic && entryIdx > 0 && unstrIdx > 0 && unstrIdx !== entryIdx && ch.ref !== "reposo";
    if (usaComodo) {
      for (j = 0; j < rows.length; j++) {
        var _su = num(rows[j][unstrIdx]), _es = num(rows[j][entryIdx]);
        if (_su == null || _es == null || _es <= _su) { usaComodo = false; break; }
      }
    }
    var sizes = rows.map(function (r) {
      var rep = unstrIdx > 0 ? num(r[unstrIdx]) : null;
      var mx = elastic && entryIdx > 0 ? num(r[entryIdx]) : null;
      var main;
      if (usaComodo) main = mx;
      else {
        main = entryIdx < 0 ? null : (elastic ? (unstrIdx > 0 ? num(r[unstrIdx]) : null) : num(r[entryIdx]));
        /* si el "máximo" no supera al sin-estirar, la tabla no tiene columna de
           cómodo real (caso Remera Basic) y el tope no aplica */
        if (mx != null && main != null && mx <= main) mx = null;
      }
      return { s: String(r[0]), main: main, max: mx, rep: rep, cint: cintIdx > 0 ? num(r[cintIdx]) : null };
    });
    return { label: label || name, name: name, cols: cols, rows: rows, sizes: sizes, img: ch.img || null,
             elastic: elastic, comodo: usaComodo, measure: entryIdx > 0 ? measure : null, ease: ease, fit: fit, hasCalc: entryIdx > 0 };
  }

  /* ---------- recomendador determinístico ---------- */
  function ranges(it) {
    var ms = it.sizes.map(function (s) { return s.main; });
    return it.sizes.map(function (sz, i) {
      if (sz.main == null || !it.ease) return { s: sz.s, lo: null, hi: null, sz: sz };
      if (it.elastic) {
        /* el rango de cada talle es el de la propia prenda: del "sin estirar" al
           contorno cómodo, que es el tope de ajuste. Entre esos dos números entran
           varias medidas de cuerpo — cuanto más cerca del tope, más al cuerpo.
           Ojo: `main` puede ser el cómodo (ver classify), así que el piso se toma
           siempre de `rep`, nunca de `main`. */
        var lo0 = sz.rep != null ? sz.rep : sz.main;
        return { s: sz.s, lo: lo0, hi: sz.max != null ? sz.max : null, sz: sz };
      }
      var lo = (i > 0 && ms[i - 1] != null) ? Math.round((ms[i - 1] + sz.main) / 2) - it.ease.ideal : sz.main - it.ease.ideal - 8;
      var hi = (i < ms.length - 1 && ms[i + 1] != null) ? Math.round((sz.main + ms[i + 1]) / 2) - it.ease.ideal : sz.main - it.ease.min;
      return { s: sz.s, lo: lo, hi: hi, sz: sz };
    });
  }
  function recommend(it, meas, pref) {
    if (!it || !it.hasCalc) return null;
    var body = meas[it.measure];
    if (body == null) return { missing: true, label: it.label, need: it.measure };
    if (body < (it.measure === "cintura" ? 45 : 55) || body > 185) return { invalid: true, label: it.label, body: body };
    var R = ranges(it), idx = -1, i, tight = false;
    if (it.elastic) {
      /* mismo criterio que las rígidas, medido sobre la columna que decide
         (el contorno CÓMODO si la tabla lo tiene medido, si no el reposo):
         se busca el talle cuya diferencia con tu cuerpo quede más cerca del
         objetivo, siempre que entres dentro de su contorno cómodo. */
      var ec = [];
      for (i = 0; i < it.sizes.length; i++) {
        var sz = it.sizes[i];
        if (sz.main == null) continue;
        /* sin columna de contorno cómodo medida, techo provisorio conservador:
           1.2x el sin-estirar (el estiramiento real medido en el catálogo va de
           1.22x a 1.65x; jersey estira menos que ribb). Se reemplaza cuando el
           depósito mida el contorno cómodo real. */
        var cap = sz.max != null ? sz.max + 2 : sz.main * 1.2;
        if (body <= cap) ec.push({ i: i, hol: sz.main - body });
      }
      if (!ec.length) return { none: true, label: it.label, body: body };
      var eb = ec[0];
      for (i = 1; i < ec.length; i++) if (Math.abs(ec[i].hol - it.ease.ideal) < Math.abs(eb.hol - it.ease.ideal)) eb = ec[i];
      idx = eb.i;
    } else {
      var cands = [];
      for (i = 0; i < it.sizes.length; i++) {
        if (it.sizes[i].main == null) continue;
        var h0 = it.sizes[i].main - body;
        if (h0 >= it.ease.min) cands.push({ i: i, hol: h0 });
      }
      if (!cands.length) {
        var last = it.sizes.length - 1;
        var lm = it.sizes[last].main;
        if (lm != null && lm - body >= it.ease.snug) { cands = [{ i: last, hol: lm - body }]; tight = true; }
        else return { none: true, label: it.label, body: body };
      }
      var best = cands[0];
      for (i = 1; i < cands.length; i++) if (Math.abs(cands[i].hol - it.ease.ideal) < Math.abs(best.hol - it.ease.ideal)) best = cands[i];
      idx = best.i;
    }
    var warn = tight ? "Es el talle más grande: te va a quedar más al cuerpo que el calce pensado para este modelo." : null;
    if (it.elastic && idx >= 0 && it.sizes[idx].max != null && body > it.sizes[idx].max - 2) {
      /* "subí un talle" solo tiene sentido si existe uno más grande */
      warn = (idx < it.sizes.length - 1)
        ? "Va bien al cuerpo, cerca de su contorno cómodo. Si la preferís más relajada, subí un talle."
        : "Es el talle más grande de este modelo. Te va a quedar bien al cuerpo, ajustado: la prenda estira, pero no queda holgada.";
    }
    var idx0 = idx;
    if (!tight && !it.elastic && it.measure === "cadera" && meas.cintura != null && meas.cintura >= 45 && meas.cintura <= 160) {
      while (idx < R.length - 1 && R[idx].sz.cint != null && R[idx].sz.cint < meas.cintura - 2) idx++;
      if (R[idx].sz.cint != null && R[idx].sz.cint < meas.cintura - 2) warn = "Tu cintura (" + meas.cintura + " cm) queda al límite incluso en el talle más grande.";
      else if (idx > idx0) warn = "Por cadera te daba el " + esc(R[idx0].s) + ", pero con tu cintura (" + meas.cintura + " cm) no cerraba: te recomendamos el " + esc(R[idx].s) + ".";
      else if (R[idx].sz.cint != null && R[idx].sz.cint - meas.cintura > 10) warn = "En la cintura te va a sobrar — este modelo es de cadera ancha. Con cinto queda como en la foto.";
    }
    var shifted = false;
    if (pref !== 0) { var ni = idx + pref; if (ni >= 0 && ni < R.length) { idx = ni; shifted = true; } }
    var r = R[idx], hol, why;
    if (it.elastic) {
      /* el texto siempre explica con las DOS columnas: reposo y cómodo.
         `main` puede ser cualquiera de las dos según decida la tabla. */
      var rep = r.sz.rep != null ? r.sz.rep : (it.comodo ? null : r.sz.main);
      hol = rep != null ? body - rep : null;
      why = "La prenda mide <b>" + (rep != null ? rep + " cm" : "—") + "</b> sin estirar" +
            (r.sz.max != null ? " y es cómoda hasta <b>" + r.sz.max + " cm</b>" : ", y el tejido cede") +
            ". Sobre tu medida se ajusta" + (hol != null ? " <b>" + hol + " cm al cuerpo</b>" : "") + ", con resto de confort.";
    } else {
      hol = r.sz.main - body;
      var fitTxt;
      if (tight) fitTxt = ".";
      else if (hol < it.ease.min) fitTxt = " — va a quedar AJUSTADO, marcando el cuerpo.";
      else if (hol < it.ease.ideal * 0.55) fitTxt = " — va al cuerpo, más pegado que en la foto.";
      else if (hol <= it.ease.ideal * 1.45) fitTxt = " — el calce con el que este modelo está pensado.";
      else fitTxt = " — va a quedar más suelto que en la foto.";
      if (shifted) fitTxt = (pref < 0 ? " — un talle menos que el sugerido:" : " — un talle más que el sugerido:") + fitTxt.replace(" —", "");
      why = "La prenda mide <b>" + r.sz.main + " cm</b> plana; sobre tus <b>" + body + " cm</b> quedan <b>" + hol + " cm de holgura</b>" + fitTxt;
    }
    return { label: it.label, size: r.s, hol: hol, why: why, warn: warn, body: body };
  }

  function chartDe(handle){
    if (!DATA) return null;
    var m = DATA.map && DATA.map[handle];
    if (!m) return null;
    var id = m.c || (m.comps && m.comps[0] && m.comps[0].c);
    return id && DATA.charts ? DATA.charts[id] : null;
  }

  const KEY = 'w7:medidas';
  const getMeas = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const setMeas = (m) => { try { m ? localStorage.setItem(KEY, JSON.stringify(m)) : localStorage.removeItem(KEY); } catch (e) {} };
  const cache = {};
  const talle = (handle, meas) => {
    const k = handle + '|' + JSON.stringify(meas);
    if (k in cache) return cache[k];
    const ch = chartDe(handle);
    const r = ch ? recommend(classify(ch), meas, 0) : null;
    return (cache[k] = r && r.size ? r.size : null);
  };
  const handleDe = (card) => {
    const a = card.querySelector('a[href*="/products/"]');
    const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  };
  const cards = () => [...document.querySelectorAll('#ProductGridContainer .card')];

  // Etiqueta «Tu talle: M» en cada tarjeta
  const badges = () => {
    const meas = getMeas();
    cards().forEach((card) => {
      const old = card.querySelector('.w7-tt');
      const h = handleDe(card);
      const s = meas && h ? talle(h, meas) : null;
      if (!s) { old && old.remove(); return; }
      const host = card.querySelector('.w7-pr') || card.querySelector('.product-card__content');
      if (!host) return;
      const el = old || document.createElement('div');
      el.className = 'w7-tt';
      el.textContent = 'Tu talle: ' + s;
      if (!old) host.appendChild(el);
    });
  };

  // Caja de la calculadora en los cajones de filtros
  const BOX = `<button type="button" class="w7-calc" aria-expanded="false"><span><b>¿No sabés tu talle?</b><small>Calculalo con tus medidas</small></span><i class="w7-chev" aria-hidden="true">+</i></button>
    <div class="w7-med" hidden>
      <div class="w7-in3">
        <label>Busto o pecho<span class="w7-cm"><input type="text" inputmode="decimal" data-m="busto" placeholder="92"><i>cm</i></span></label>
        <label>Cintura<span class="w7-cm"><input type="text" inputmode="decimal" data-m="cintura" placeholder="76"><i>cm</i></span></label>
        <label>Cadera<span class="w7-cm"><input type="text" inputmode="decimal" data-m="cadera" placeholder="100"><i>cm</i></span></label>
      </div>
      <div class="w7-reco" aria-live="polite"></div>
      <p class="w7-note">Medí con un centímetro, sin apretar. Usamos la tabla real de cada prenda. Para jeans y pantalones cargá cintura y cadera.</p>
    </div>`;
  const resumen = (meas) => {
    const n = {};
    cards().forEach((c) => { const h = handleDe(c); const s = h ? talle(h, meas) : null; if (s) n[s] = (n[s] || 0) + 1; });
    return Object.entries(n).sort((a, b) => b[1] - a[1]);
  };
  const pintar = (box) => {
    const meas = {};
    box.querySelectorAll('[data-m]').forEach((i) => { const v = num(i.value); if (v) meas[i.dataset.m] = v; });
    const reco = box.querySelector('.w7-reco');
    if (!meas.busto && !meas.cadera && !meas.cintura) { reco.innerHTML = ''; setMeas(null); badges(); return; }
    setMeas(meas); badges();
    const r = resumen(meas);
    if (!r.length) { reco.innerHTML = '<span>Con esas medidas no encontramos talle en estas prendas. Revisá los números.</span>'; return; }
    reco.innerHTML = '<span>Tu talle en esta página: ' + r.map(([s, c]) => `<b>${s}</b> <small>(${c} ${c === 1 ? 'prenda' : 'prendas'})</small>`).join(' · ') + '</span><button type="button" class="w7-usar">Usar estos talles</button>';
    reco.querySelector('.w7-usar').onclick = () => {
      const drawer = box.closest('drawer-element');
      const want = new Set(r.map(([s]) => s));
      const inputs = [...drawer.querySelectorAll('.w7-g-tal input.checkbox')];
      let changed = null;
      inputs.forEach((inp) => {
        const lbl = drawer.querySelector(`label[for="${CSS.escape(inp.id)}"]`);
        const t = (lbl ? lbl.firstChild.textContent : inp.value).trim();
        const on = want.has(t);
        if (inp.checked !== on && !inp.disabled) { inp.checked = on; changed = inp; }
      });
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    };
  };
  const montar = () => {
    ['FacetDrawerSticky', 'FacetDrawer'].forEach((id) => {
      const d = document.getElementById(id);
      const tal = d && d.querySelector('.w7-g-tal');
      if (!tal || tal.querySelector('.w7-medbox')) return;
      const box = document.createElement('div');
      box.className = 'w7-medbox';
      box.innerHTML = BOX;
      tal.querySelector('.details__content').appendChild(box);
      const meas = getMeas();
      if (meas) box.querySelectorAll('[data-m]').forEach((i) => { if (meas[i.dataset.m]) i.value = meas[i.dataset.m]; });
      box.querySelector('.w7-calc').onclick = () => {
        const med = box.querySelector('.w7-med');
        med.hidden = !med.hidden;
        box.classList.toggle('open', !med.hidden);
        box.querySelector('.w7-calc').setAttribute('aria-expanded', String(!med.hidden));
        box.querySelector('.w7-chev').textContent = med.hidden ? '+' : '−';
        if (!med.hidden) pintar(box);
      };
      box.querySelectorAll('[data-m]').forEach((i) => i.addEventListener('input', () => pintar(box)));
    });
  };

  // Ficha (WEB-07 25-oct): expone «Tu talle en esta prenda» para w7-pdp.js
  const startFicha = () => {
    fetch(window.w7GtUrl).then((r) => r.json()).then((j) => {
      DATA = j;
      window.w7TalleDe = (handle) => {
        let m = getMeas();
        if (!m) { try { m = JSON.parse(localStorage.getItem('gt_meas_v1') || 'null'); } catch (e) { m = null; } }
        if (!m || (!m.busto && !m.cadera && !m.cintura)) return null;
        return talle(handle, m);
      };
      document.dispatchEvent(new CustomEvent('w7:talle-listo'));
    }).catch(() => {});
  };

  const start = () => {
    if (window.w7GtUrl && document.querySelector('product-info') && !document.getElementById('ProductGridContainer')) return startFicha();
    if (!window.w7GtUrl || !document.getElementById('ProductGridContainer')) return;
    fetch(window.w7GtUrl).then((r) => r.json()).then((j) => {
      DATA = j;
      montar(); badges();
      let t;
      new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => { montar(); badges(); }, 120); })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }).catch(() => {});
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
